import React from 'react';
import { cn } from '../../utils/cn';
import Button from '../primitives/Button';

export type Tab = {
  id: string;
  label: string;
};

export type TabSwitcherProps = {
  tabs: Tab[];
  currentTab: string;
  onTabChange: (id: string) => void;
  className?: string;
  colorScheme?: 'light' | 'dark';
  layout?: 'horizontal' | 'vertical';
};

const TabSwitcher: React.FC<TabSwitcherProps> = ({ 
  tabs, 
  currentTab, 
  onTabChange, 
  className = '', 
  colorScheme = 'light',
  layout = 'horizontal',
}) => {


  return (
    <div role="tablist" aria-label="Tabs" className={cn(
      "relative gap-0", 
      layout === 'vertical' ? 'flex flex-col' : 'flex',
      className
    )}>
      {tabs.map((tab) => (
        <Button
          key={tab.id}
          variant="secondary"
          role="tab"
          aria-selected={currentTab === tab.id}
          aria-controls={`tabpanel-${tab.id}`}
          id={`tab-${tab.id}`}
          tabIndex={currentTab === tab.id ? 0 : -1}
          className={cn(
            'relative px-4 py-2 font-medium rounded-none border-0 border-b-2',
            currentTab === tab.id
              ? 'bg-white text-teal-700 border-b-2 border-teal-700'
              : 'bg-white text-gray-700 hover:bg-gray-50 hover:text-gray-700 border-b-2 border-gray-200'
          )}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.label}
        </Button>
      ))}
    </div>
  );
};

export default TabSwitcher; 